import { HttpLink } from '@apollo/client/core';

export const link = new HttpLink({
  uri: window.__pixelConfig.APP_API
});
